module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_EE-bc2e09e6ed83fcfb13aab06eb18f6ca6.svg";